import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const orderApi = createApi({
  reducerPath: 'orderApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/order/',
    prepareHeaders: (headers, { getState }) => {
      // Получаем токен из Redux state
      let { auth: { auth } } = getState()
      if (typeof auth == "string") {
        auth = JSON.parse(auth);
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["order"],
  endpoints: (builder) => ({
    getOrders: builder.query({
      query: (data) => {
        if (data && typeof data === "object" && !Array.isArray(data)) {
          return {
            url: `orderListAdmin`,
            params: data
          }
        } else {
          return {
            url: `orderListAdmin`,
            params: {
              status: data
            }
          }
        }
      },
      providesTags: ["order"],
    }),
    getManifestData: builder.query({
      query: ({ partial, partial_code }) => {
        return {
          url: `manifest-data`,
          params: {
            partial: partial,
            partial_code: partial_code
          }
        }
      },
    }),
    getOrdersByClentCode: builder.query({
      query: ({
        statusId,
        clientCode
      }) => {
        return {
          url: `order-by-clientcode`,
          params: {
            status: statusId,
            clientCode: clientCode
          }
        }
      },
      providesTags: ["order"],
    }),
    getOrderByTCode: builder.query({
      query: ({ tcode, boxId, status }) => {
        return {
          url: `order-tracking-code`,
          params: {
            tcode: tcode,
            boxId: boxId,
            status: status
          }
        }
      },
      providesTags: ["order", "box"],
    }),
    getOrderByPartial: builder.query({
      query: (partialCode) => {
        return {
          url: `partial-order`,
          params: {
            partialCode: partialCode
          }
        }
      },
      invalidatesTags: ["order"],
    }),
    getOrderSearch: builder.query({
      query: ({ tcode }) => {
        return {
          url: `order-search`,
          params: {
            tcode: tcode
          }
        }
      },
      invalidatesTags: ["order"],
    }),
    getOrderSearchByBarcodes: builder.query({
      query: ({ tcodes }) => {
        return {
          url: `order-arr-search`,
          params: {
            tcodes: tcodes
          }
        }
      },
      invalidatesTags: ["order"],
    }),
    createOrUpdateOrder: builder.mutation({
      query: (formData) => {
        return {
          url: `createEditOrderAdmin`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["order"],
    }),
    upsertOrder: builder.mutation({
      query: (formData) => {
        return {
          url: `order-upsert`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["order"],
    }),
    updatetUserOrder: builder.mutation({
      query: (formData) => {
        return {
          url: `order-update-user`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["order"],
    }),
    updateSetUser: builder.mutation({
      query: (body) => {
        return {
          url: "set-user",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["order"],
    }),
    createByBarcodes: builder.mutation({
      query: (body) => {
        return {
          url: "create-by-barcode",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["order"],
    }),
    pandingToProcess: builder.mutation({
      query: (body) => {
        return {
          url: "panding-to-process",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["order"],
    }),
    acceptOrder: builder.mutation({
      query: (body) => {
        return {
          url: "accept-order",
          body: body,
          method: "Post"
        }
      },
      invalidatesTags: ["order"],
    }),
    deliverOrder: builder.mutation({
      query: (body) => {
        return {
          url: "to-deliver-order",
          body: body,
          method: "POST"
        }
      },
      invalidatesTags: ["order"],
    }),
    issueOrder: builder.mutation({
      query: ({ guid }) => ({
        url: `/issue/${guid}`,
        method: "POST",
      }),
      invalidatesTags: ["order"],
    }),
    updateUserPackages: builder.mutation({
      query: (body) => ({
        url: `/v2/rule/package-order`,
        method: "POST",
        body: body
      }),
      invalidatesTags: ["order"],
    }),
  }),
})

export const { useGetOrdersQuery,
  useGetManifestDataQuery,
  useGetOrdersByClentCodeQuery,
  useCreateOrUpdateOrderMutation,
  useGetOrderByTCodeQuery,
  useGetOrderSearchQuery,
  useUpdateSetUserMutation,
  useCreateByBarcodesMutation,
  usePandingToProcessMutation,
  useGetOrderByPartialQuery,
  useUpdatetUserOrderMutation,
  useAcceptOrderMutation,
  useIssueOrderMutation,
  useUpsertOrderMutation,
  useGetOrderSearchByBarcodesQuery,
  useDeliverOrderMutation,
  useUpdateUserPackagesMutation } = orderApi